"use client";

import { useEffect } from "react";

import { getCurrentSessionContext } from "@/app/actions";
import { initializeStoreFromContext } from "@/app/store";

export function UserManager(): null {
	useEffect(() => {
		getCurrentSessionContext().then((context) => {
			if (context) {
				initializeStoreFromContext(context);
			}
		});
	}, []);

	return null;
}
